import { render } from "./Fileupload.vue?vue&type=template&id=67c5711a&scoped=true"
import script from "./Fileupload.vue?vue&type=script&lang=js"
export * from "./Fileupload.vue?vue&type=script&lang=js"

import "./Fileupload.vue?vue&type=style&index=0&id=67c5711a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c5711a"]])

export default __exports__